  import React, { useEffect } from 'react';
  import Navbar          from './components/Navbar';
  import Hero            from './components/Hero';
  import About           from './components/About';
  import WhyChooseUs     from './components/WhyChooseUs';
  import Services        from './components/Services';
  import CTABanner       from './components/CTABanner';
  import Founder         from './components/Founder';
  import Staff           from './components/Staff';
  import Testimonials    from './components/Testimonials';
  import Contact         from './components/Contact';
  import Footer          from './components/Footer';
  import WhatsAppButton  from './components/WhatsAppButton';

  export default function App() {
    useEffect(() => {
      const els = document.querySelectorAll('.reveal');
      const obs = new IntersectionObserver(
        (entries) => entries.forEach((e) => {
          if (e.isIntersecting) e.target.classList.add('visible');
        }),
        { threshold: 0.08 }
      );
      els.forEach((el) => obs.observe(el));
      return () => obs.disconnect();
    }, []);

    return (
      <>
        <Navbar />
        <main>
          <Hero />
          <About />
          <WhyChooseUs />
          <Services />
          <CTABanner />
          <Staff />
          <Founder />
          <Testimonials />
          <Contact />
        </main>
        <Footer />
        <WhatsAppButton />
      </>
    );
  }
